export const SectionHeader = ({ eyebrow, title, subtitle, align = "left", testId }) => {
  const centered = align === "center";
  return (
    <div className={`max-w-2xl ${centered ? "mx-auto text-center" : ""}`} data-testid={testId}>
      {eyebrow ? (
        <p
          className="text-xs font-semibold uppercase tracking-[0.18em]"
          style={{ color: "var(--gm-muted-2)" }}
        >
          {eyebrow}
        </p>
      ) : null}
      <h2 className="mt-2.5 text-2xl font-bold text-white sm:text-3xl lg:text-[2.5rem]">
        {title}
      </h2>
      {subtitle ? (
        <p
          className="mt-3 text-sm leading-relaxed sm:text-base"
          style={{ color: "var(--gm-muted)" }}
        >
          {subtitle}
        </p>
      ) : null}
    </div>
  );
};
